import { defineStore } from "pinia";
import type { TelegramState, TelegramUser } from "@/interfaces";

export const useTelegramStore = defineStore('telegramStore', {
  state: (): TelegramState => ({
    telegramUser: {
      id: 444,
      first_name: '',
      last_name: '',
      username: '',
      language_code: '',
      allows_write_to_pm: false,
      photo_url: ''
    }
  }),
  actions: {
    async setParsedUser(initData: string) {
      if (initData) {
        const params = new URLSearchParams(initData);
        params.forEach((value, key) => {
          if (key === 'user') {
            try {
              const userData = JSON.parse(decodeURIComponent(value)) as TelegramUser;
              this.telegramUser = userData;
            } catch (error) {
              console.error('Error parsing user data:', error);
            }
          }
        });
      }
    },
  }
})